module.exports = __webpack_public_path__ + "assets/img/Mac.b2def541.svg";